//@ts-check
var PRIMARY_ORANGE_COLOR = '#FF6633';
var PRIMARY_TEXT_COLOR = '#000000';
var GREY_HOVER_COLOR = '#F3F5F7';
var GREY_ACTIVE_COLOR = '#E0E5EB';
/**@type {import("theme/types").PartialEcrionTheme} */

var theme = {
  variant: 'microservice',
  common: {
    Page: {
      Common: {
        style: {
          backgroundColor: 'rgb(255, 255, 255)'
        }
      },
      NavBar: {
        style: {
          color: PRIMARY_TEXT_COLOR,
          backgroundColor: '#FFF'
        },
        props: {
          variant: 'microservice'
        }
      },
      ToolBar: {
        style: {
          backgroundColor: 'rgb(247, 247, 247)'
        }
      },
      SideBar: {
        style: {
          backgroundColor: 'rgb(247, 247, 247)'
        }
      }
    },
    Data: {
      Grid: {
        style: {
          selectionColor: GREY_ACTIVE_COLOR,
          contextMenuOpenedColor: GREY_ACTIVE_COLOR
        }
      }
    }
  },
  palette: {
    primary: {
      main: GREY_ACTIVE_COLOR
    },
    secondary: {
      main: PRIMARY_ORANGE_COLOR
    }
  },
  overrides: {
    MuiPaper: {
      root: {
        backgroundColor: '#F3F5F7'
      }
    },
    MuiOutlinedInput: {
      input: {
        padding: 8,
        fontSize: 14
      }
    },
    MuiTab: {
      root: {
        letterSpacing: '0px',
        fontWeight: 600
      }
    },
    MuiIconButton: {
      root: {
        borderRadius: 6
      }
    },
    MuiButton: {
      root: {
        borderRadius: 6,
        padding: '4px 16px'
      },
      outlined: {
        padding: '4px 16px'
      },
      contained: {
        padding: '4px 16px'
      }
    },
    MuiMenuItem: {
      root: {
        '&:hover, &:focus': {
          backgroundColor: GREY_HOVER_COLOR,
          color: PRIMARY_TEXT_COLOR
        },
        '&:active': {
          backgroundColor: GREY_ACTIVE_COLOR,
          color: PRIMARY_TEXT_COLOR
        },
        '&$selected': {
          backgroundColor: GREY_ACTIVE_COLOR,
          color: PRIMARY_TEXT_COLOR,
          '&:hover': {
            backgroundColor: GREY_HOVER_COLOR,
            color: PRIMARY_TEXT_COLOR
          },
          '&:active, &:focus': {
            backgroundColor: GREY_ACTIVE_COLOR,
            color: PRIMARY_TEXT_COLOR
          }
        }
      }
    }
  }
};
export default theme;